import { groupBy, memoize } from 'dpl/util';

export const BREED_TYPES = {
  ALL: 'All',
  PUREBRED: 'Purebred',
  CROSSBRED: 'Crossbred'
};

export const ORDERED_BREED_TYPES = Object.values(BREED_TYPES);

export function getBreedsForQuery(breeds, query) {
  if (!breeds) { return []; }
  if (!query) { return breeds; }

  query = query.toLowerCase();

  const res = breeds.filter(({ _lowerName }) =>
    _lowerName.includes(query)
  );

  return res;
}

function getNormalizedBreeds(breeds) {
  // order by `live == true`, then `purebred == true`
  return [...breeds].sort((b1, b2) => {
    if (b1.live !== b2.live) {
      return b1.live ? -1 : 1;
    }

    if (b1.hybrid !== b2.hybrid) {
      return b2.hybrid ? -1 : 1;
    }

    return 0;
  }).map(b => ({
    ...b,
    _lowerName: b.name.toLowerCase()
  }));
}

export const getGroupedBreeds = memoize((breeds) => {
  breeds = getNormalizedBreeds(breeds);

  const {
    true: hybridBreeds = [],
    false: pureBreeds = []
  } = groupBy(breeds, 'hybrid');

  return {
    [BREED_TYPES.ALL]: breeds,
    [BREED_TYPES.PUREBRED]: pureBreeds,
    [BREED_TYPES.CROSSBRED]: hybridBreeds
  };
}, (breeds, query) => {
  if (!CONFIG.isProduction) { return `${query}-${breeds.length}`; }
  return breeds.length;
});
